import React from 'react';
import DepositTransferCard from './components/DepositTransferIndex.jsx';

const DepositTransfer = ({program}) => {
  return (
      <DepositTransferCard program={program} />
  )
}

export default DepositTransfer;
